import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  CardActions,
  ListBase,
  Loading,
  Pagination,
  useAuthenticated,
  useListContext,
  useTranslate,
} from "react-admin";
import React, { useEffect, useState } from "react";
import { getLocalDate, getLocalTime } from "../../utils";

import AddMemberButton from "./components/AddMemberButton";
import FilterDialog from "./components/FilterDialog";
import FilterMemberButton from "./components/FilterMemberButton";
import MemberInfoPanel from "../../components/MemberInfoPanel";
import Phone from "../../components/Phone";
import PublishIcon from "@material-ui/icons/Publish";
import SearchBarwithButton from "../../components/SearchBarwithButton";
import SfBreadcrumb from "../../components/SfBreadcrumbs";
import TierMedal from "../../components/TierMedal";
import { isLiteVersion } from "../../utils/settings";
import moment from "moment";
import useBranches from "../../hooks/useBranches";
import { useHistory } from "react-router-dom";
import useImport from "../../hooks/useImport";
import useSFAlert from "../../hooks/useSFAlert";
import useSFLoading from "../../hooks/useSFLoading";
import useSFSuccess from "../../hooks/useSFSuccess";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    flex: "1 0 auto",
    marginTop: theme.defaultMarginTop,
    boxSizing: "border-box",
    display: "flex",
    position: "absolute",
    top: 0,
    bottom: 0,
  },
  title: theme.title,
  breadcrumb: {
    marginTop: 20,
    alignSelf: "start",
  },
  leftPanel: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 0 auto",
  },
  rightPanel: {
    backgroundColor: theme.white,
    overflowY: "auto",
  },
  dataGrid_rowEven: {
    backgroundColor: "gray", //Not work
  },
  dataGrid_rowOdd: {
    backgroundColor: "red", //Not work
  },

  proceedButtonContainer: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    maxWidth: 682,
    height: 99,
    display: "flex",
    justifyContent: "center",
    position: "fixed",
    bottom: "0",
  },
  spaceforProceedButton: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    height: 99,
    display: "flex",
    justifyContent: "center",
    //width: "100%",
  },
  proceedButton: {
    width: 322,
    height: 57,
    fontSize: 28,
    fontWeight: "bold",
    alignSelf: "center",
  },
  filterBar: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(10,1fr)",
    gap: 15,
    justifyContent: "end",
    padding: 10,
    boxSizing: "border-box",
  },
  searchButton: {
    borderRadius: 12,
  },
  searchandFilterContainer: {
    display: "grid",
    gridTemplateColumns: "400px 150px auto",
    columnGap: 8,
    alignItems: "center",
  },
  input: {
    display: "none",
  },
  faceImage: {
    color: theme.palette.primary.light,
  },
}));

const MemberList = (props) => {
  useAuthenticated();
  const classes = useStyles();
  const translate = useTranslate();
  const [memberInfo, setMemberInfo] = useState();
  const history = useHistory();
  const [foundUser, setFoundUser] = useState(false);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [tierFilter, setTierFilter] = useState(-1);
  const [nonActiveFilter, setNonActiveFilter] = useState();
  const [activeFilter, setActiveFilter] = useState();
  const [repeatFilter, setRepeatFilter] = useState();
  const [amountFilter, setAmountFilter] = useState();
  const [lifeTimeValueFilter, setLifeTimeValueFilter] = useState();
  const [pointFilter, setPointFilter] = useState();
  const { importFile } = useImport();
  const [showLoading, hideLoading] = useSFLoading();
  const [showSuccess] = useSFSuccess();
  const [alert] = useSFAlert();

  const filterObject = {};
  if (tierFilter !== -1) {
    filterObject["tier_id"] = tierFilter.id;
  }

  if (nonActiveFilter) {
    filterObject["last_transaction_time"] = {
      $gte: new Date("2021-01-01"),
      $lte: moment().subtract(nonActiveFilter, "months"),
    };

    //filterObject["_last_transaction_time"] = "2021-06-21T08:36:50.857Z";
  }

  if (activeFilter) {
    filterObject["last_transaction_time"] = {
      $gte: moment().subtract(activeFilter, "months"),
      $lte: moment(),
    };

    //filterObject["_last_transaction_time"] = "2021-06-21T08:36:50.857Z";
  }

  if (repeatFilter) {
    filterObject["accum.payment.total_transaction"] = {
      $gte: Number(repeatFilter.from),
      $lte: Number(repeatFilter.to),
    };
  }

  if (lifeTimeValueFilter) {
    filterObject["accum.payment.total_revenue"] = {
      $gte: Number(lifeTimeValueFilter.from),
      $lte: Number(lifeTimeValueFilter.to),

      //      $lt: lifeTimeValueFilter.to,
    };

    //filterObject["accum.payment.total_revenue"] = lifeTimeValueFilter;
  }

  const handleCapture = async ({ target }) => {
    //setSelectedFile(target.files[0]);

    showLoading();
    const [, error] = await importFile({
      file: target.files[0],
      type: "members",
    });
    if (error) {
      const message =
        error || error.message ? error.message : "Error: Something went wrong.";
      alert(JSON.stringify(message));
    } else {
      showSuccess();
    }
    hideLoading();
    target.value = null; //Make able to repeat same file
  };

  // const handleSubmit = () => {
  //   //saveFace(selectedFile);
  // };

  return (
    <Box className={classes.allContainer}>
      <Grid container>
        <Grid item xs={8} className={classes.leftPanel}>
          <SfBreadcrumb
            path="/Customer Insight/Members"
            className={classes.breadcrumb}
          />
          <Box
            style={{
              width: "100%",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Box
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto 1fr",
                gap: "5px",
                justifyItems: "center",
                width: "100%",
              }}
            >
              <Typography
                style={{
                  gridColumnStart: 2,
                }}
              >
                {translate("ra.text.memberSearch.selectaMember")}
              </Typography>
              <Box style={{ marginLeft: "auto" }}>
                <input
                  accept="*/*"
                  className={classes.input}
                  id="faceImage"
                  type="file"
                  onChange={handleCapture}
                />

                <Tooltip title="Upload File">
                  <label htmlFor="faceImage">
                    <IconButton
                      className={classes.faceImage}
                      color="primary"
                      aria-label="upload file"
                      component="span"
                    >
                      <PublishIcon />
                    </IconButton>
                  </label>
                </Tooltip>
              </Box>
              {/* <Button style={{ marginLeft: "auto" }}>
                Upload
                <input type="file" hidden />
              </Button> */}
            </Box>

            <ListBase
              {...props}
              debounce={1000}
              resource="members"
              basePath="/payment/search-member"
              filter={filterObject}
              bulkActionButtons={false}
              // perPage={5}
              actions={<NoneActions />}
              style={{ width: "100%" }}
              sort={{ field: "None", order: "DSC" }}
            >
              <Box className={classes.searchandFilterContainer}>
                <Search />
                <AddMemberButton />
                <FilterMemberButton onClick={() => setDisplayFilter(true)} />
              </Box>
              <Box className={classes.filterBar}>
                {tierFilter !== -1 ? (
                  <Chip
                    label={"Tier:" + tierFilter.name}
                    onDelete={() => setTierFilter(-1)}
                    color="primary"
                  />
                ) : null}
                {nonActiveFilter ? (
                  <Chip
                    label={"Non active:" + nonActiveFilter}
                    onDelete={() => setNonActiveFilter(null)}
                    color="primary"
                  />
                ) : null}
                {activeFilter ? (
                  <Chip
                    label={"Active:" + activeFilter}
                    onDelete={() => setActiveFilter(null)}
                    color="primary"
                  />
                ) : null}

                {repeatFilter ? (
                  <Chip
                    label={
                      "Repeat:" + repeatFilter.from + " - " + repeatFilter.to
                    }
                    onDelete={() => setRepeatFilter(null)}
                    color="primary"
                  />
                ) : null}

                {lifeTimeValueFilter ? (
                  <Chip
                    label={
                      "LTV:" +
                      lifeTimeValueFilter.from +
                      "-" +
                      lifeTimeValueFilter.to
                    }
                    onDelete={() => setLifeTimeValueFilter(null)}
                    color="primary"
                  />
                ) : null}
              </Box>
              <MyDatagrid
                memberInfo={memberInfo}
                setMemberInfo={setMemberInfo}
                setFoundUser={setFoundUser}
                pageName="Member"
              />
              <Box>
                <Pagination rowsPerPageOptions={[10]} />
              </Box>
            </ListBase>
            {foundUser ? (
              <Box className={classes.proceedButtonContainer}>
                <Button
                  className={classes.proceedButton}
                  variant="contained"
                  color="primary"
                  disabled={memberInfo ? false : true}
                  onClick={() =>
                    history.push({
                      pathname: `/ci/member/profiles/${memberInfo.id}`,
                    })
                  }
                >
                  {translate("ra.text.proceed")}
                </Button>
              </Box>
            ) : null}
          </Box>
          <Box className={classes.spaceforProceedButton}></Box>
        </Grid>
        <Grid item xs={4} className={classes.rightPanel}>
          {memberInfo ? <MemberInfoPanel id={memberInfo.id} /> : null}
        </Grid>
      </Grid>
      <FilterDialog
        open={displayFilter}
        onClose={() => {
          setDisplayFilter(false);
          setMemberInfo();
        }}
        tierFilter={tierFilter}
        nonActiveFilter={nonActiveFilter}
        activeFilter={activeFilter}
        repeatFilter={repeatFilter}
        amountFilter={amountFilter}
        lifeTimeValueFilter={lifeTimeValueFilter}
        pointFilter={pointFilter}
        setTierFilter={setTierFilter}
        setNonActiveFilter={setNonActiveFilter}
        setActiveFilter={setActiveFilter}
        setRepeatFilter={setRepeatFilter}
        setAmountFilter={setAmountFilter}
        setPointFilter={setPointFilter}
        setLifeTimeValueFilter={setLifeTimeValueFilter}
      />
    </Box>
  );
};
const NoneActions = () => <CardActions />;

const handleClickMember = (record, setMemberInfo) => {
  setMemberInfo({ ...record });
};

const Search = () => {
  const { setFilters, filterValues } = useListContext();
  const [, setSearchText] = useState();
  const translate = useTranslate();
  return (
    <SearchBarwithButton
      onChange={(e) => {
        if (e.target.value === "") {
          const newFilterValues = { ...filterValues };
          delete newFilterValues.keyword;
          setFilters(newFilterValues);
        } else {
          setFilters({ ...filterValues, keyword: e.target.value });
        }
        setSearchText(e.target.value);
      }}
      placeholder={translate("ra.text.ci.searchMember")}
      onSearch={null}
      buttonLabel={translate("ra.action.search")}
    />
  );
};

const useMyDataGridStyles = makeStyles((theme) => ({
  tableContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "scroll",
    backgroundColor: "transparent",
  },
  loadingContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "none",
  },
  rowContainer: {
    backgroundColor: theme.white,
  },
  rowContainer_selected: {
    backgroundColor: theme.lightOrange,
  },
  rowHeight: {
    maxHeight: 68,
    paddingTop: 5,
    paddingBottom: 5,
    height: 68,
    boxSizing: "border-box",
    paddingLeft: "10px",
    paddingRight: 5,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fullname: { ...theme.h7 },
  time_text: { fontSize: 14 },
  point: {
    fontSize: 14,
    marginLeft: 4,
    fontWeight: "bold",
    //color: theme.orange,
  },
  pointIcon: {
    width: 25,
    height: 25,
  },
  selectButton: {
    width: 89,
    height: 30,
  },
  titleTableText: {
    fontSize: 14,
  },
  tableHead: {
    height: 29,
    padding: "0 10px",
    boxSizing: "border-box",
    backgroundColor: "transparent",
  },
  branchandTotal: {
    display: "flex",
    justifyContent: "space-between",
  },
  transparent: {
    backgroundColor: "transparent",
  },
  gray: {
    backgroundColor: "rgba(235, 235, 235, 0.8)",
  },
  bold: {
    fontWeight: "bold",
    paddingLeft: 5,
  },
  tags_text: {
    fontSize: 14,
    width: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 2,
  },
}));

const MyDatagrid = ({
  memberInfo,
  setMemberInfo,
  setFoundUser,
  isPrinting,
  pageName,
}) => {
  const { data, ids, loading, total } = useListContext();
  const classes = useMyDataGridStyles();
  const { setFilters } = useListContext();
  const translate = useTranslate();
  const {
    branches,
    loading: branchLoading,
    //    error: errorBranch,
  } = useBranches();
  useEffect(() => {
    setFilters({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading || branchLoading)
    return (
      <TableContainer className={classes.tableContainer}>
        <Loading className={classes.loadingContainer} />
      </TableContainer>
    );

  setFoundUser(ids.length > 0);
  return (
    <>
      {isPrinting && (
        <Box style={{ textAlign: "center", padding: 12 }}>
          <Typography style={{ fontSize: 18, fontWeight: "600" }}>
            {pageName}
          </Typography>
        </Box>
      )}
      <TableContainer className={classes.tableContainer}>
        <Table classes={{ root: classes.transparent }}>
          {ids.length > 0 ? (
            <>
              <TableHead classes={{ root: classes.transparent }}>
                <TableRow classes={{ root: classes.transparent }}>
                  <TableCell className={classes.tableHead}>
                    <Typography className={classes.titleTableText} noWrap>
                      {translate("ra.text.ci.lastActivity")}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tableHead}>
                    <Typography className={classes.titleTableText}>
                      {translate("ra.text.ci.tier")}
                    </Typography>
                  </TableCell>

                  <TableCell className={classes.tableHead}>
                    <Typography className={classes.titleTableText} noWrap>
                      {translate("ra.text.ci.nameandPhoneNumber")}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tableHead}>
                    <Typography className={classes.titleTableText} noWrap>
                      {translate("ra.text.ci.tags")}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tableHead}>
                    <Typography className={classes.titleTableText} noWrap>
                      {translate("ra.text.ci.ltv")}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tableHead}>
                    <Box className={classes.branchandTotal}>
                      <Typography className={classes.titleTableText}>
                        {translate("ra.text.branch")}
                      </Typography>
                      <Typography
                        className={[classes.titleTableText, classes.bold]}
                      >
                        {translate("ra.text.bi.total")} {total}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ids.map((id, index) => {
                  const record = data[id];
                  //const id = record.id;
                  return (
                    <TableRow
                      key={id}
                      role="checkbox"
                      classes={{
                        root:
                          index % 2 === 0 ? classes.transparent : classes.gray,
                      }}
                      hover
                      onClick={() => handleClickMember(record, setMemberInfo)}
                      selected={memberInfo ? id === memberInfo.id : false}
                    >
                      {/* first column: selection checkbox */}
                      <TableCell className={classes.rowHeight}>
                        <Box className={classes.flexRow}>
                          <Box>
                            <Typography className={classes.time_text}>
                              {getLocalDate(record.last_transaction_time)}
                            </Typography>
                            <Typography className={classes.time_text}>
                              {getLocalTime(record.last_transaction_time)}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <TierMedal
                          image={record.tier.current.image_url}
                          name={record.tier.current.name}
                        />
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.fullname} noWrap>
                          {record.firstname} {record.lastname}
                        </Typography>

                        <Phone number={record.phone} />
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.tags_text}>
                          {record?.tags?.map((tag) => "#" + tag).join(", ")}
                        </Typography>
                      </TableCell>

                      <TableCell className={classes.rowHeight}>
                        <Box className={classes.flexRow}>
                          <Typography className={classes.point}>
                            {Number(
                              record.lifetime_value?.total_revenue ?? 0
                            ).toLocaleString()}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.point}>
                          {
                            branches?.find((b) => b.id === record.branch_id)
                              ?.name
                          }
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </>
          ) : (
            <NotFoundView />
          )}
        </Table>
      </TableContainer>
    </>
  );
};

const useNotFoundViewStyles = makeStyles((theme) => ({
  allContainer: {
    backgroundColor: theme.layoutBackground,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  redText: {
    marginTop: 17,
    color: theme.red,
    marginLeft: 72,
    marginRight: 72,
  },
  registerTitle: {
    marginTop: 93,
  },
  registerButton: { marginTop: 26, width: 322, height: 57, fontSize: 28 },
  or: {
    marginTop: 40,
  },
  addPaymentTitle: {
    marginTop: 24,
  },
  addPaymentButton: {
    marginTop: 14,
    width: 322,
    height: 57,
    fontSize: 28,
  },
}));

const NotFoundView = () => {
  const classes = useNotFoundViewStyles();
  const history = useHistory();
  return (
    <Box className={classes.allContainer}>
      <Typography className={classes.redText} align="center">
        We cannot find this name. Please try again with phone number or register
        for new member
      </Typography>
      <Typography className={classes.registerTitle} align="center">
        Could not find the member? Register for new member here
      </Typography>
      <Button
        className={classes.registerButton}
        variant="contained"
        color="primary"
        onClick={() => history.push("/customers/register")}
      >
        Register
      </Button>
      <Typography className={classes.or} align="center">
        OR
      </Typography>
      <Typography className={classes.addPaymentTitle} align="center">
        Proceed with non-member
      </Typography>
      <Button
        className={classes.addPaymentButton}
        variant="contained"
        color="primary"
        onClick={() =>
          history.push({
            pathname: isLiteVersion() ? "/payment/lite" : "/payment/addproduct",
            state: { memberInfo: null },
          })
        }
      >
        Add Payment
      </Button>
    </Box>
  );
};

export default MemberList;
